import React, {useCallback, useEffect, useState, useRef} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FeedContentsTable from './tables/FeedContentsTable';
import {useDispatch, useSelector} from 'react-redux'
import endpoints, {getBackendUrl} from '../../endpoints';
import {storage} from '../../storage';
import axios from 'axios';
import withAlert from '../../hoc/withAlerts'
import Loading from '../pages/parts/Loading'
import Stack from '@mui/material/Stack';
import BasicModal from './modals/BasicModal'
import AddTagForm from './forms/AddTagForm';
import { setHeader } from '../../redux/headerSlice'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

function Reports(props) {
    const [tagsList, setTagsList] = useState([])
    const [list, setList] = useState([])
    const [pagination, setPagination] = useState({
        page: 1,
        perpage: 10,
        total: 0
    })
    const [perpage, setPerpage] = useState(storage.reports.perpage)
    const [loading, setLoading] = useState(false)
    const [modalAddOpen, setModalAddOpen] = useState(false)
    const [modalWriteCoverOpen, setModalWriteCoverOpen] = useState(false)
    const [selectedId, setSelectedId] = useState(null);
    const [finder, setFinder] = useState(storage.reports.finder);
    const [filterTags, setFilterTags] = useState(storage.reports.filterTags);
    const [filterSearch, setFilterSearch] = useState(storage.reports.filterSearch);
    const [filterFrom, setFilterFrom] = useState(storage.reports.filterFrom);
    const [filterTo, setFilterTo] = useState(storage.reports.filterTo);
    const [filterType, setFilterType] = useState(storage.reports.filterType);
    const [findersList, setFindersList] = useState([]);
    const [analyzeItem, setAnalyzeItem] = useState();
    const [finderItem, setFinderItem] = useState();
    const [analyzeData, setAnalyzeData] = useState();
    
    const applyBtn = useRef()

    const dispatch = useDispatch()
    const testMode = useSelector((state) => state.testmode.testModeState)
    const token = useSelector((state) => state.auth.token)
    
    const withoutTagsLabel = 'No any Tags'

    const showAlertError = useCallback((message) => {
        props.showAlert(message, 'error')
    }, [props])

    const getTagsList = useCallback(async () => {
        let uri = getBackendUrl(endpoints.tags, token)
        try {
            let res = await axios.get(uri)
            setTagsList(res.data.items)
        } catch (e) {
            showAlertError('Unknown Error - get tags list')
        }
    }, [token, showAlertError])

    const getFindersList = useCallback(async () => {
        let uri = getBackendUrl(endpoints.finders, token)
        try {
            let res = await axios.get(uri)
            setFindersList(res.data.items)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            console.log(e)
            showAlertError('Unknown Error - get Feed contents list ')
        }
    }, [showAlertError, token])

    const getList = async (page) => {
        storage.reports.finder = finder;
        storage.reports.filterType = filterType;
        storage.reports.perpage = perpage;
        storage.reports.filterTags = filterTags;
        storage.reports.filterSearch = filterSearch;
        storage.reports.filterFrom = filterFrom ? filterFrom : null;
        storage.reports.filterTo = filterTo ? filterTo : null;
        
        let uri = getBackendUrl(endpoints.reports, token)
        uri = uri.replace('{id}', storage.reports.finder)
        uri = uri.replace('{type}', storage.reports.filterType)

        const params = {}
        if (page) {
            params.page = page
        }
        if (perpage) {
            params.perpage = perpage
        }
        if (filterTags.length) {
            params.tags = filterTags.join(',')
        }
        if (filterSearch) {
            params.filter = filterSearch
        }
        if (filterFrom) {
            if (filterFrom.$y) {
                let y = filterFrom.$y
                let m = filterFrom.$M + 1
                if (m < 10) {
                    m = '0' + m
                }
                let d = filterFrom.$D
                if (d < 10) {
                    d = '0' + d
                }
                params.datefrom = y + '-' + m + '-' + d
            }
        }
        if (filterTo) {
            if (filterTo.$y) {
                let y = filterTo.$y
                let m = filterTo.$M + 1
                if (m < 10) {
                    m = '0' + m
                }
                let d = filterTo.$D
                if (d < 10) {
                    d = '0' + d
                }
                params.dateto = y + '-' + m + '-' + d
            }
        }

        try {
            setLoading(true)
            const res = await axios.get(uri, {params: params})
            setList(res.data.items)
            setPagination({
                page: res.data.page + 1,
                perpage: res.data.perpage,
                total: res.data.total,
                pages: Math.ceil(res.data.total / res.data.perpage)
            })
            setLoading(false)
        } catch (e) {
            setLoading(false)
            showAlertError('Unknown Error - get Feed contents list')
        }
    }

    const handlePaginate = (value) => {
        window.scrollTo(0, 0)
        getList(value)
    }
    
    const refreshHandler = async () => {
        await getList(pagination.page - 1)
        getAnalyzeData()
    }
    
    const getAnalyzeData = async () => {
        if (storage.reports.finder > 0) {
            let uri = getBackendUrl(endpoints.finders_analyze, token).replace('{id}', storage.reports.finder)
            try {
                const res = await axios.get(uri)
                
                let noTags = res.data.withoutTags;
                let success = null;
                let total = res.data.total;
                if (total > 0 && total > noTags) {
                    let falseTotal = res.data.falseTotal;
                    let error = res.data.error;
                    let result = (total - falseTotal - error) / total;
                    success = Math.round(result * 1000) / 1000;
                } else {
                    success = 'No Data';
                }
                
                setAnalyzeData({
                    success: success,
                    noTags: res.data.withoutTags,
                })
            } catch (e) {
                showAlertError('Unknown Error - get Analyze Report')
                setAnalyzeData(null);
            }
        } else {
            setAnalyzeData(null);
        }
    }

    const openWriteCoverModal = (row) => {
        setSelectedId(row.id)
        setModalWriteCoverOpen(true)
    }

    const handleChangePerpage = (value) => {
        window.scrollTo(0, 0)
        setPerpage(value)
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    const handleChangeFinder = (e) => {
        window.scrollTo(0, 0)
        setFinder(e.target.value)
    }
    
    const feedsUpdatedHandler = () => {
        window.scrollTo(0, 0)
        if (applyBtn.current) {
            applyBtn.current.click()
            getAnalyzeData();
        }
    }
    
    useEffect(() => {
        getFindersList()
        getTagsList()
        dispatch(setHeader({
            title: 'Reports'
        }))
        
        window.removeEventListener('FEEDS_CONTENTS_UPDATED', feedsUpdatedHandler)
        window.addEventListener('FEEDS_CONTENTS_UPDATED', feedsUpdatedHandler)
    }, []);
    
    useEffect(() => {
        getList()
    }, [perpage, finder, filterType]);
    
    useEffect(() => {
        getAnalyzeData()
    }, [finder]);

    return (
        <Stack sx={{maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '20px'}}>
            <Grid container spacing={2} alignItems="center">
                <Grid item sx={{width:'100%'}}>
                    <Stack direction="row" spacing={2} alignItems="center" sx={{width:'100%'}}>
                        <Typography variant="h5" gutterBottom sx={{paddingTop: 2}}>
                            Reports for
                        </Typography>
                        <FormControl variant="standard" sx={{ width: '200px', paddingTop:1.5}}>
                            <Select
                                fullWidth
                                label="Finder"
                                onChange={handleChangeFinder}
                                value={storage.reports.finder}
                            >
                                <MenuItem key='all' value='all'>All Finders</MenuItem>
                                {
                                    findersList.map((row, key) => (
                                        <MenuItem key={key} value={row.id}>{row.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <FormControl sx={{ paddingTop: 1.3 }}>
                            <Button 
                                variant="contained" 
                                size="small" 
                                disabled={finder > 0 ? false : true}
                                onClick={() => {setFinderItem(finder)}}
                            >
                                Properties
                            </Button>
                        </FormControl>
                        {testMode && (
                        <FormControl sx={{ paddingTop: 1.3 }}>
                            <Button 
                                variant="contained" 
                                size="small" 
                                color="error" 
                                disabled={finder > 0 ? false : true} 
                                onClick={() => {setAnalyzeItem(finder)}}
                            >
                                Run Finder
                            </Button>
                        </FormControl>
                        )}
                        <Stack sx={{ flexGrow: 1 }}/>
                        <Typography variant="h5" gutterBottom sx={{pt: 0.75, pr: 3}}>
                            No Tags: {analyzeData?.noTags}
                        </Typography>
                        <Typography variant="h5" gutterBottom sx={{pt: 0.75}}>
                            Success: {analyzeData?.success}
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
            <Stack spacing={2} direction="row" sx={{ pb: 2 }}>
                <FormControl variant="standard" sx={{ width: '300px'}}>
                    <InputLabel id="tagsFilterLabel">Tags</InputLabel>
                    <Select
                        fullWidth
                        labelId="tagsFilterLabel"
                        label="Tags"
                        value={filterTags}
                        onChange={(e) => setFilterTags(e.target.value)}
                        multiple
                        variant="standard"
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value, key) => (
                                    <Chip key={value} label={tagsList.find((item) => {
                                        return item.id == value
                                    })?.name ?? withoutTagsLabel} size="small"/>
                                ))}
                            </Box>
                        )}
                    >
                        {tagsList.map((row, key) => (
                            <MenuItem key={key} value={row.id} sx={{p:0, pl:1, pr:1}}>
                                <Checkbox checked={filterTags.indexOf(row.id) > -1} />
                                <ListItemText primary={row.name} />
                            </MenuItem>
                        ))}
                        <MenuItem key='empty' value='empty' sx={{p:0, pl:1, pr:1}}>
                            <Checkbox checked={filterTags.indexOf('empty') > -1} />
                            <ListItemText primary={withoutTagsLabel} />
                        </MenuItem>
                    </Select>
                </FormControl>
                <TextField 
                    variant="standard" 
                    sx={{ width: '200px' }}
                    label="Search"
                    defaultValue={filterSearch}
                    onChange={(e) => {setFilterSearch(e.target.value)}}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker label="Date From" 
                        sx={{ width: '140px' }} 
                        slotProps={{ textField: { variant: 'standard' } }}
                        onChange={setFilterFrom}
                        defaultValue={filterFrom}/>
                    <DatePicker 
                        label="Date To" 
                        sx={{ width: '140px' }} 
                        slotProps={{ textField: { variant: 'standard' } }}
                        onChange={setFilterTo}
                        defaultValue={filterTo}/>
                </LocalizationProvider>
                <FormControl variant="standard" sx={{ paddingTop:1.5 }}>
                    <Button variant="contained" ref={applyBtn} onClick={() => getList(0)}>Apply</Button>
                </FormControl>
            </Stack>
            <Stack alignItems="center">
                <RadioGroup row onChange={(e) => {setFilterType(e.target.value)}} value={filterType}>
                    <FormControlLabel value="suitable" control={<Radio />} label="Suitable" />
                    <FormControlLabel value="notsuitable" control={<Radio />} label="Not Suitable" />
                    <FormControlLabel value="error" control={<Radio />} label="Error" />
                    <FormControlLabel value="all" control={<Radio />} label="All" />
                </RadioGroup>
            </Stack>
            <FeedContentsTable
                items={list}
                pagination={pagination}
                handlePaginate={handlePaginate}
                handleChangePerpage={handleChangePerpage}
                onRefresh={refreshHandler}
                btnWriteCover={openWriteCoverModal}
            />
            {loading ? <Loading/> : null}
        </Stack>
    );
}

export default withAlert(Reports)
